module.exports = __webpack_public_path__ + "static/img/pic1.adffc58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/news/pic1.png
// module id = BzC3
// module chunks = 1